import { Typography } from "@mui/material";
import parse from "html-react-parser";
import { useSharedStateWithActions } from "../../../../common/hooks/useSharedState";
import { AppConstants, sharedStateKeys } from "../../../../constants/constant";
import "./DisclaimerTerms.css";
import { useFormContext } from "../../../../common/contexts/FormContext";
interface DisclaimerTermsProps {
  currentStepType: string;
  elementId?: string;
}

const DisclaimerTerms: React.FC<DisclaimerTermsProps> = ({
  currentStepType,
  elementId,
}: DisclaimerTermsProps) => {
  const { state } = useSharedStateWithActions();
  const { formValues } = useFormContext();
  const hideTerms =
    sessionStorage.getItem("countryCode") === AppConstants.COUNTRY_CA;
  return (
    <>
      {currentStepType === AppConstants.CONTACT_US_TYPE &&
        !formValues.hideOptinTerms &&
        !hideTerms && (
          <Typography
            data-testid="disclaimer-terms"
            id={elementId}
            dangerouslySetInnerHTML={{
              __html:
                parse(
                  state[sharedStateKeys.DISCLAIMER_TERMS]
                    ? state[sharedStateKeys.DISCLAIMER_TERMS]
                    : ""
                ) || "",
            }}
          ></Typography>
        )}
    </>
  );
};

export default DisclaimerTerms;
